export default __webpack_public_path__ + "static/media/mailingList.fcedff5a.png";